module.exports = __webpack_public_path__ + "static/media/NotoSans-Italic.85c1b6fe.ttf";